import { useEffect } from "react";
import { openUpgradeModal } from "../../models/upgradeModal";

/**
 * Remplaçant de la petite modale de limite de plan : quand la création d'un
 * bien est bloquée par le plafond du plan, ouvre directement la modale globale
 * « Changer d'offre » (Particuliers / Agence / Investisseur).
 */
const PropertyCheck = ({ planModal, setplanModal }) => {
  useEffect(() => {
    if (planModal) {
      setplanModal?.(false);
      openUpgradeModal({ action: "create_property" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planModal]);

  return null;
};

export default PropertyCheck;